export default "__VITE_ASSET__DcD_EAL9__"